import { useContext } from "react";
import { AuthContext } from "@/contexts/AuthContext";
import type { IAuthContext } from "@/application/ports/IAuthContext";

export function useAuth(): IAuthContext {
	const context = useContext(AuthContext);
	if (!context) {
		throw new Error("useAuth must be used within an AuthProvider");
	}
	return context;
}
